<template>
  <v-main>
    <v-container fluid>
      <template v-if="error_status === 404">
        <Error404 />
      </template>
      <template v-else>
        <Error />
      </template>
    </v-container>
  </v-main>
</template>

<script>
import store from '../../store/index.js'
import Error404 from "../organisms/Error/Error404.vue"
import Error from "../organisms/Error/Error.vue"

export default {
  name: 'ErrorPage',
  components: {
    Error404,
    Error,
  },
  data() {
    return {
      error_status: store.getters['error/getErrorStatus'],
      error_status_text: store.getters['error/getErrorStatusText']
    }
  }
}
</script>